import colors from './colors';
const borders = {
    base: {
        borderWidth: '0.2rem',
        borderStyle: 'solid',
        overflow: 'hidden'
    },
    bottom: {
        borderBottomWidth: '0.2rem',
        borderBottomStyle: 'solid'
    },
    shape: {
        pill: {
            borderRadius: '99999px'
        },
        rounded: {
            borderRadius: '1rem'
        },
        veryRounded: {
            borderRadius: '2rem'
        }
    },
    variant: {
        primary: {
            borderColor: colors.brand.primary.alpha
        },
        secondary: {
            borderColor: colors.neutrals.borderBeta
        },
        inverted: {
            borderColor: colors.neutrals.background
        },
        outline: {
            borderColor: colors.brand.primary.alpha
        },
        outlineSecondary: {
            borderColor: colors.neutrals.borderBeta
        },
        invertedOutline: {
            borderColor: colors.neutrals.background
        }
    },
    disabled: {
        borderColor: colors.neutrals.borderBeta
    },
    error: {
        borderColor: colors.status.fail.alpha
    }
};
export default borders;
//# sourceMappingURL=borders.js.map